import { RootState } from '@store/store';

// Get the comment unlock response
export const getCommentUnlockResponse = (state: RootState) => state.employer.resume.commentUnlockResponse;
